import { FormField, QuestionnaireDescription, SelectField as Select } from "common";
import { noop } from "lodash";
import React from "react";
import { FieldProps } from "./TextField";

export const SelectField = ({ name, field, classNames, showDescription = true, onChange }: FieldProps) => {
    return (
        <FormField label={field.label} name={name} classNames={{ label: classNames?.label }}>
            {showDescription && <QuestionnaireDescription field={field} />}
            <Select
                // This uses only for old Pickup questionnaire fields that use as select
                disabled={field.readonly && field.label === "Pickup location"}
                onChange={onChange ? (e) => onChange(e.target.value) : noop}
            >
                <option />

                {field.options?.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </Select>
        </FormField>
    );
};
